import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { DownOutline } from 'antd-mobile-icons';
import { ComponentDefaults } from './type';
import { usePropsValue } from './use-props-value';
import useTableSticky from './useTableSticky';
const defaultProps = {
    ...ComponentDefaults,
    columns: [],
    data: [],
    bordered: true,
    striped: false,
    noData: '',
    sorterIcon: null,
    showHeader: true,
};
export const Table = (props) => {
    const { children, className, style, columns, data, bordered, summary, striped, noData, sorterIcon, showHeader, onSort, ...rest } = {
        ...defaultProps,
        ...props,
    };
    const sortedMapping = useRef({});
    const [innerValue, setValue] = usePropsValue({
        defaultValue: data,
        finalValue: [],
    });
    const { isSticky, stickyLeftWidth, stickyRightWidth, getStickyClass, getStickyStyle } = useTableSticky(columns);
    useEffect(() => {
        setValue(data);
    }, [data]);
    const classPrefix = 'nut-table';
    const headerClassPrefix = `${classPrefix}-main-head-tr`;
    const bodyClassPrefix = `${classPrefix}-main-body-tr`;
    const cls = classNames(classPrefix, className);
    const handleSorterClick = (item) => {
        if (item.sorter && !sortedMapping.current[item.key]) {
            const copied = [...innerValue];
            if (typeof item.sorter === 'function') {
                copied.sort(item.sorter);
            }
            else if (item.sorter === 'default') {
                copied.sort();
            }
            sortedMapping.current[item.key] = true;
            setValue(copied, true);
            onSort && onSort(item, copied);
        }
        else {
            sortedMapping.current[item.key] = false;
            setValue(data);
        }
    };
    const cellClasses = (item) => {
        return {
            [`${headerClassPrefix}-border`]: bordered,
            [`${headerClassPrefix}-align${item.align ? item.align : ''}`]: true,
        };
    };
    const getColumnItem = (value) => {
        return columns.filter((item) => item.key === value)[0];
    };
    const renderHeadCells = () => {
        return columns.map((item, index) => {
            return (React.createElement("div", { className: classNames(`${headerClassPrefix}-th`, cellClasses(item), getStickyClass(item.key)), key: item.key, onClick: () => handleSorterClick(item), style: getStickyStyle(item.key) },
                item.title,
                "\u00A0",
                item.sorter && (sorterIcon || React.createElement(DownOutline, { width: "12px", height: "12px" }))));
        });
    };
    const sortDataItem = () => {
        return columns.map((columns) => {
            return [columns.key, columns.render];
        });
    };
    const renderBodyTds = (item, rowIndex) => {
        const { rowRender } = item;
        if (rowRender && typeof rowRender === 'function') {
            return rowRender(item, rowIndex);
        }
        return sortDataItem().map(([value, render]) => {
            return (React.createElement("div", { className: classNames(`${bodyClassPrefix}-td`, cellClasses(getColumnItem(value)), getStickyClass(value)), key: value, style: getStickyStyle(value) }, typeof item[value] === 'function' || typeof render === 'function' ? (React.createElement("div", null, render ? render(item[value], item, rowIndex) : item[value](item))) : (item[value])));
        });
    };
    const renderBodyTrs = () => {
        return innerValue.map((item, index) => {
            return (React.createElement("div", { className: bodyClassPrefix, key: index }, renderBodyTds(item, index)));
        });
    };
    return (React.createElement("div", Object.assign({ className: cls }, rest),
        React.createElement("div", { className: classNames(`${classPrefix}-wrapper ${isSticky ? `${classPrefix}-wrapper-sticky` : ''}`), style: style },
            React.createElement("div", { className: classNames(`${classPrefix}-main`, {
                    [`${classPrefix}-main-striped`]: striped,
                }) },
                showHeader && (React.createElement("div", { className: `${classPrefix}-main-head` },
                    React.createElement("div", { className: headerClassPrefix }, renderHeadCells()))),
                React.createElement("div", { className: `${classPrefix}-main-body` }, renderBodyTrs()))),
        isSticky ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `${classPrefix}-sticky-left`, style: { width: stickyLeftWidth } }),
            React.createElement("div", { className: `${classPrefix}-sticky-right`, style: { width: stickyRightWidth } }))) : null,
        (summary || innerValue.length === 0) && (React.createElement("div", { className: `${classPrefix}-summary` }, summary || noData))));
};
Table.displayName = 'NutTable';
